import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { AppConfigService } from 'src/app/core/services/config.service';
import { AppSpecialLoadingBorderColor } from 'src/app/core/types/app-special-loading-border-color.type';
import { AppSpecialLoadingIconColor } from 'src/app/core/types/app-special-loading-icon-color.type';

@Component({
    selector: 'app-special-loading',
    templateUrl: './special-loading.component.html',
    styleUrls: ['./special-loading.component.scss'],
    standalone: false
})
export class SpecialLoadingComponent implements OnInit {
  //#region propertis
  @Input() imgSrc: string;
  @Input() type:
    | 'sending'
    | 'calculate'
    | 'pishgamSending'
    | 'pishgamCalculate'
    | 'custom' = 'sending';
  @Input() imgMaxWidth: string = '140px';
  @Input() bgColor: AppSpecialLoadingIconColor = 'blue';
  @Input() borderColor: AppSpecialLoadingBorderColor = 'white';
  @Input() message: string;

  cssBgColor: string;
  borderStyle: string;
  isOwnerPanel: boolean = false;
  appUrl: string = AppConfigService.config.appUrl;
  //#endregion

  constructor(protected translate: TranslateService) { }

  ngOnInit() {
    if (window.location.origin == this.appUrl) this.isOwnerPanel = true;
    this.getContentLoading();

    this.cssBgColor = `var(--color-${this.bgColor})`;
  }

  getContentLoading() {
    if (this.isOwnerPanel && this.type == 'calculate')
      this.type = 'pishgamCalculate';
    if (this.isOwnerPanel && this.type == 'sending')
      this.type = 'pishgamSending';

    switch (this.type) {
      case 'calculate':
        this.imgSrc = 'assets/media/gif/calculate.gif';
        this.message = 'messages.calcSmsPrice';
        this.imgMaxWidth = '110px';
        break;
      case 'pishgamCalculate':
        this.imgSrc = 'assets/media/gif/pishgamCalculate.gif';
        this.message = 'messages.calcSmsPrice';
        this.imgMaxWidth = '162px';
        break;
      case 'sending':
        this.imgSrc = 'assets/media/gif/sending.gif';
        this.message = 'messages.sendingSms';
        break;
      case 'pishgamSending':
        this.imgSrc = 'assets/media/gif/pishgamSending.gif';
        this.message = 'messages.sendingSms';
        this.imgMaxWidth = '200px';
        break;
      case 'custom':
        break;
      default:
        break;
    }
  }
}
